module.exports = __webpack_public_path__ + "img/banner-title.d1d49c5b.png";